export type OneArticleModifer = 'copy' | 'insert' | 'link' | 'preview';
export type OneArticleTecDocLinkingTargetsModifier = 'insert' | 'preview';
export type OneReportsModifier = 'new-report';

export enum OneRoutes {
  _Default = 'myproducts',
  Accessorylist = 'accessorylist',
  AccessoryLinkages = 'accessory-linkages',
  AcesArticleLinkagesByTarget = 'aces-article-linkages-by-target',
  AdvancedReporting = 'advanced-reporting',
  ArticleAcesLinkingTargets = 'aces-linkage-targets',
  ArticleAcesLinkingTargetsCountryVio = 'aces-linkage-targets-country-vio',
  ArticleAcesLinkingTargetsVio = 'aces-linkage-targets-vio',
  ArticleCustomLinkageTargets = 'custom-linkage-targets',
  ArticleGTIN = 'article-gtin',
  ArticlePackaging = 'article-packaging',
  ArticlePreview = 'myproducts/preview',
  ArticlePrices = 'article-prices',
  ArticleStatuses = 'article-statuses',
  ArticleSupersededby = 'article-superseded-by',
  ArticleTecDocLinkingTargets = 'tecdoc-linkage-targets',
  ArticleTecDocLinkingTargetsVio = 'tecdoc-linkage-targets-vio',
  ArticleTextBlocks = 'article-text-blocks',
  ArticleTradenumbers = 'article-tradenumbers',
  AuthCheck = 'authcheck',
  AutocareExport = 'autocare-export',
  ControlPanel = 'control-panel',
  ControlPanelTecdocAppChanges = 'tecdoc-applications',
  ControlPanelDQM = 'dqm-issues',
  Copy = 'copy',
  CoverageGapAnalysisInteract = 'coverage-gap-analysis-interact',
  CoverageGapAnalysisVioStateProvince = 'coverage-gap-analysis-vio-state-province',
  CrossReferences = 'cross-references',
  Dashboard = 'home',
  DataLoader = 'data-loader',
  IdpTransfers = 'idp-transfers',
  Import = 'import',
  ImportCriteria = 'myproducts/import/criteria',
  Importer = 'importer',
  ImportFile = 'import-file',
  Insert = 'insert',
  Link = 'link',
  LinkageTargets = 'linkage-targets',
  LinkageTargetsEditor = 'linkage-targets-editor',
  AssetLinks = 'asset-links',
  MediaManager = 'media-manager',
  MyProducts = 'myproducts',
  MyTargets = 'my-targets',
  NewExport = 'new-export',
  NewQuery = 'new-query',
  NewVehicles = 'new-vehicles',
  OEReferences = 'oe-references',
  Partslist = 'partslist',
  Scheduler = 'scheduler',
  SensitiveGraphic = 'sensitive-graphic',
  Preview = 'preview',
  ProductLinkageAdvisor = 'product-linkage-advisor',
  Profile = 'profile',
  RangeExtensionInteract = 'range-extension-interact',
  RangeExtensionVioNationals = 'range-extension-vio-nationals',
  RangeExtensionVioStateProvince = 'range-extension-vio-state-province',
  ReleaseNotes = 'release-notes',
  Reports = 'reporting',
  ReportsNew = 'new-report',
  Result = 'result',
  RevalidationAssistant = 'revalidation-assistant',
  SearchResults = 'search',
  Settings = 'settings',
  ShowCase = 'showcase',
  SuperAdmin = 'super-admin',
  SupersessionExtensionsInteract = 'supersession-extensions-interact',
  TecDocArticleLinkagesByTarget = 'tecdoc-article-linkages-by-target',
  TecDocArticleLinkagesByTargetSetOrder = 'tecdoc-article-linkages-by-target-set-order',
  TecDocLinkageTargetsVio = 'tecdoc-linkage-targets-vio',
  TranslationManager = 'translation-manager',
  TecDocArticleLinkagesEngineTransposition = 'tecdoc-engine-transposition',
  ShoppingListInteract = 'shopping-list-interact',
  UserRoles = 'users-roles',
  UserPermissions = 'users-permissions',
  DataLoaderNew = 'new-data-loader',
}
